import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import useStyle from './style';

export default function BoxMenu({ setOpenOptionImages, setOpenColorOptions }) {
  const classes = useStyle();
  const [bgUrl, _] = useState([
    'https://images.unsplash.com/photo-1500051638674-ff996a0ec29e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3492&q=80',
    'https://images.pexels.com/photos/1279813/pexels-photo-1279813.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260',
  ]);

  const openOptions = (type) => {
    if (type === 'image') {
      setOpenOptionImages(true);
      setOpenColorOptions(false);
    } else {
      setOpenOptionImages(false);
      setOpenColorOptions(true);
    }
  };

  return (
    <Box className={classes.menu}>
      <Box
        className={classes.box}
        style={{
          backgroundImage: `url(
      '${bgUrl[0]}')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
        onClick={() => openOptions('image')}
      >
        <span>Photo</span>
      </Box>

      <Box
        className={classes.box}
        style={{
          backgroundImage: `url(
      '${bgUrl[1]}')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
        onClick={() => openOptions('color')}
      >
        <span>Color</span>
      </Box>
    </Box>
  );
}
